// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../assets/images/Image_1920x300.webp");
exports = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
exports.push([module.id, ".backgroundColor[data-v-ab6a5aea]{background-color:#f8f9fa}.homeBanner[data-v-ab6a5aea]{background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ");color:#fff;padding:3rem!important}@media screen and (max-width:600px){.homeBanner[data-v-ab6a5aea]{padding:1rem!important}}.back-buton[data-v-ab6a5aea]{position:absolute;margin:10px 10px auto;z-index:500;cursor:pointer}", ""]);
// Exports
module.exports = exports;
